import React, { Component, Fragment } from 'react'
import DashboardLayout from '../components/Admin/DashboardLayout'
import {
  MDBBtn,
  MDBContainer,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalDialog,
  MDBModalContent,
  MDBModalTitle,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../components/content/MDB4Datatable/MDB4Datatable.component'
import AdminApi from '../api/admin-api/admin-api'
import { toast } from 'react-toastify'

class Products extends Component {
  constructor(props) {
    super(props)
    this.state = {
      productsList: '',
      loading: '',
      error: '',
      modal: false,
      confirmModal: false,
      viewdata: '',
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Product',
            field: 'name',
            sort: 'asc',
            width: 280,
          },
          {
            label: 'Carrier',
            field: 'carrier',
            sort: 'asc',
            width: 200,
          },
          {
            label: 'Coverage',
            field: 'coverage',
            sort: 'asc',
            width: 280,
          },
          {
            label: 'Update',
            field: 'update',
            sort: 'disabled',
            width: 80,
          },
          {
            label: 'Delete',
            field: 'delete',
            sort: 'disabled',
            width: 80,
          },
        ],
        rows: [],
      },
    } // state end
  }

  componentDidMount() {
    this.fetchProductsData()
  }

  //convert date from sec to current date
  toDateTime = secs => {
    let t = new Date(1970, 0, 1) // Epoch
    t.setSeconds(secs)
    return t
  }

  //toggle modal
  toggle = () => {
    this.setState({ modal: !this.state.modal })
  }

  //calling delete confirm modal
  confirm_DeleteProduct = data => {
    this.confirm_toggle(data)
  }

  //Toggle delete confirm modal
  confirm_toggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  //forming rows for data table from fetched data
  setRows = () => {
    const { productsList } = this.state
    if (productsList && productsList.length) {
      let rows = productsList.map(row => {
        const { carrier_name, product_coverage_names, p_name, id } = row
        const self = this

        function editProduct() {
          self.props.history.push(`/add-product/${id}/edit`)
        }

        function deleteProduct() {
          self.confirm_DeleteProduct({ viewdata: row })
        }

        const editClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={editProduct}>
              <MDBIcon icon='edit' size='2x' className='blue-text p-1' />
            </div>
          </div>
        )

        const deleteClick = (
          <div className={'d-flex align-items-center justify-content-center'}>
            <div className={'cursor-pointer d-inline-block'} role={'button'} onClick={deleteProduct}>
              <MDBIcon icon='trash' size='2x' className='red-text p-1' />
            </div>
          </div>
        )

        const coverageList = (
          <div data-searchvalue={product_coverage_names}>
            {product_coverage_names.split('<br />').map((item, i) => {
              return <div key={`p${i}`}>{item}</div>
            })}
          </div>
        )

        return {
          name: p_name,
          carrier: carrier_name ? carrier_name : 'N/A',
          // coverage: productcoverages ? productcoverages.split(",").length : 0,
          coverage: coverageList,
          update: editClick,
          delete: deleteClick,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  //Fetch data
  fetchProductsData = async () => {
    this.setState({ loading: true })

    try {
      const result = await AdminApi.getProductsList()
      const products = result.data.data || []

      this.setState({ productsList: products, loading: false }, () => this.setRows())
    } catch (error) {
      this.setState({ loading: false })
      toast.error(error.message, { position: toast.POSITION.TOP_RIGHT })
    }
  }

  //Delete data
  _DeleteProduct = async id => {
    this.setState({ deleting: true })
    const data = { type: 'products', id: id }

    AdminApi.deleteProduct(data)
      .then(result => {
        this.setState({ deleting: false })
        this.confirm_toggle()
        toast.success('Product successfully deleted', {
          position: toast.POSITION.TOP_RIGHT,
        })
        this.fetchProductsData()
      })
      .catch(error => {
        this.setState({ deleting: false })
        toast.error(`${error.message}`, { position: toast.POSITION.TOP_RIGHT })
      })
  }

  render() {
    toast.configure()
    const { data, confirmModal, loading } = this.state

    const createNew = () => {
      this.props.history.push('/add-product')
    }

    return (
      <Fragment>
        <DashboardLayout>
          <main className='mainSection pb-5'>
            <MDBContainer fluid className='mt-5'>
              <h2>
                Products
                <div className='d-inline-block'>
                  <MDBBtn
                    type='button'
                    color='default'
                    tag='a'
                    floating
                    gradient='blue'
                    title={'Add New Product'}
                    onClick={createNew}
                  >
                    <MDBIcon icon='plus' />
                  </MDBBtn>
                </div>
              </h2>
              <hr />
              {loading ? (
                <h4 className={'p4'}>
                  <MDBIcon className='red-text ms-3' icon='cog' spin size='2x' fixed />
                  <span className='sr-only'>Loading...</span>
                </h4>
              ) : (
                <div className='content-wrapper'>
                  <MDB4Datatable
                    data={data}
                    responsive
                    striped
                    order={['name', 'asc']}
                    sortRows={['coverage']}
                    entriesOptions={[50, 75, 100]}
                    entries={50}
                    bordered
                    small
                    className='text-capitalize'
                  />
                </div>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirm_toggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete Product</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirm_toggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this Product?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirm_toggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this._DeleteProduct(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </Fragment>
    )
  }
}

export default Products
